import ProductCard from '@repo/ui/src/components/ContentGrid/ProductCard';
import { useVipAccess } from '@hooks/customer';

interface GridItemProps {
  item: any;
  content?: {
    saleText?: string;
    newText?: string;
    outOfStockText?: string;
  };
}

const GridItem = ({ item, content }: GridItemProps) => {
  const { saleText, newText, outOfStockText } = content || {};
  const { vip } = useVipAccess();

  return (
    <ProductCard
      product={item}
      saleText={saleText}
      newText={newText}
      outOfStockText={outOfStockText}
      vip={vip}
      className="grid-item !bg-white !border-0"
    />
  );
};

export default GridItem;
